import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { ControlModeTemplate } from '@src/types/ControlModes';

export default () =>
  useApiQuery<ControlModeTemplate[]>({
    queryKey: [QueryKeys.controlModeTemplates],
    apiPath: '/control-mode-templates',
    method: 'GET',
    useV2API: true,
  });
